module.exports = __webpack_public_path__ + "img/source3_14.a0f7c495.png";